import { spotlightContentClick, } from './spotlight-content-actions.js';
/**
 * Returns the possible spotlight content action creators.
 *
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category SpotlightContent
 */
export function loadSpotlightContentActions() {
    return {
        spotlightContentClick,
    };
}
